import React, { useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { samplePages } from '../data/landing';
interface SamplesSectionProps {
  layout?: 'carousel' | 'grid';
}
export function SamplesSection({
  layout = 'carousel'
}: SamplesSectionProps) {
  const trackRef = useRef<HTMLUListElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollTo = (index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(samplePages.length - 1, index));
    const item = track.children[clamped] as HTMLElement | undefined;
    if (item) {
      track.scrollTo({
        left: item.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
    setActiveIndex(clamped);
  };
  return <section aria-labelledby="muestras" className="bg-cream-deep" data-id="element-170" data-mp="3d7xxqzexbw4p">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" style={{
      backgroundColor: "#FCFCFC",
      backgroundImage: "none"
    }} data-id="element-171" data-mp="388249u3urn3e">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-172" data-mp="1h9kw684z7wqq">
          <SectionHeading align="left" eyebrow="Mira el material por dentro" title={<>
                Esto es <span className="italic text-coral" data-id="element-174" data-mp="1q9zldil29vzi">lo que vas a estudiar.</span>
              </>} intro="Páginas reales del material, un tema por página en formato A4." data-id="element-173" data-mp="1lawq2puvv44q" />

          {layout === 'carousel' ? <div className="flex shrink-0 gap-3" data-id="element-175" data-mp="203zwc130xvg5">
              <button type="button" onClick={() => scrollTo(activeIndex - 1)} aria-label="Ver ejemplo anterior" className="flex h-12 w-12 items-center justify-center rounded-full border border-line bg-cream text-ink transition-colors duration-150 ease-out-expo hover:bg-white" data-id="element-176" data-mp="250729tvf76y3">
                <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-177" data-mp="eosqyxpidipe" />
              </button>
              <button type="button" onClick={() => scrollTo(activeIndex + 1)} aria-label="Ver ejemplo siguiente" className="flex h-12 w-12 items-center justify-center rounded-full border border-line bg-cream text-ink transition-colors duration-150 ease-out-expo hover:bg-white" data-id="element-178" data-mp="jndqeuwxrycs">
                <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-179" data-mp="1i1t186egco20" />
              </button>
            </div> : null}
        </div>

        <ul ref={trackRef} className={layout === 'carousel' ? 'no-scrollbar mt-12 flex snap-x snap-mandatory gap-6 overflow-x-auto pb-2' : 'mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3'} data-id="element-180" data-mp="1qzmtn693ixjw">
          {samplePages.map(sample => <li key={sample.title} className={layout === 'carousel' ? 'flex w-[15.5rem] shrink-0 snap-start flex-col sm:w-[18rem]' : 'flex flex-col'} data-id="element-181" data-mp="20x9h4h4gnxfh">
              <div className="overflow-hidden" data-id="element-182" data-mp="2ao41ffy5cmya">
                <img src={sample.image} alt={`Página de ejemplo del nivel ${sample.level.replace('Ejemplo ', '')}: ${sample.title}`} className="w-full object-contain" style={{
              objectFit: "contain"
            }} data-id="element-183" data-mp="2apf4tenojsov" />
              </div>
              <span className="mt-5 text-xs font-semibold uppercase tracking-[0.16em] text-coral" data-id="element-184" data-mp="2jmzar0whmd5t">
                {sample.level}
              </span>
              <h3 className="mt-2 font-display text-xl leading-snug text-ink" data-id="element-185" data-mp="388dp0mnc9uo8">{sample.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-186" data-mp="2tbecckdmrbmw">{sample.body}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}